/**
 * Sistema de Multi-Producto para Configurador de Cristales
 * Inspirado en Miller&Marc - Añade múltiples productos al carrito con groupId
 */

// @ts-nocheck

class LensCartMultiProduct {
  constructor(configurator) {
    this.configurator = configurator;
    this.groupId = `lens-group-${Date.now()}`;
    this.addonProducts = new Map();
    
    // IDs de productos addon en tu tienda Shopify
    this.ADDON_PRODUCT_IDS = {
      lensTypes: {
        'progressive': '49720018534713', // Ejemplo - reemplazar con ID real
        'bifocal': '49720018534714',
        'reading': '49720018534715'
      },
      materials: {
        'standard': '49720018534716',
        'thin': '49720018534717',
        'ultra_thin': '49720018534718'
      },
      treatments: {
        'anti_scratch': '49720018534719',
        'anti_reflection': '49720018534720',
        'blue_filter': '49720018534721'
      }
    };
    
    console.log('🔄 Multi-Product Cart System initialized with groupId:', this.groupId);
  }

  /**
   * Construye la lista de items para añadir al carrito
   */
  buildCartItems(mainProductId, mainProductQuantity = 1) {
    const items = [];
    
    // 1. Producto principal (gafas)
    const mainItem = {
      id: mainProductId,
      quantity: mainProductQuantity,
      properties: {
        '_p_groupId': this.groupId,
        '_p_productType': 'main',
        '_p_hasLensConfiguration': 'true',
        '_configuracion_de_cristales': 'incluida',
        ...this.buildConfigurationProperties(),
        // Compatibility helper for price overrides
        '_precio_adicional_cristales': String(this.configurator.lensPrice || 0),
        '_precio_total_calculado': this.configurator.formatPrice((this.configurator.basePrice || 0) + (this.configurator.lensPrice || 0))
      }
    };
      // Añadir magnificación legible y técnica si existe en configurator
      try {
        const cfg = this.configurator.configuration || {};
        if (cfg.magnification) {
          const raw = String(cfg.magnification).trim();
          const normalized = raw.startsWith('+') ? raw.slice(1) : raw;
          mainItem.properties['_magnification'] = String(cfg.magnification);
          mainItem.properties['Graduación'] = normalized;
        }
      } catch (e) {}
    
    items.push(mainItem);
    
    // 2. Addon: Tipo de cristal
    if (this.configurator.configuration.lensType && 
        this.configurator.configuration.lensType !== 'single') {
      const lensTypeId = this.ADDON_PRODUCT_IDS.lensTypes[this.configurator.configuration.lensType];
      if (lensTypeId) {
        items.push({
          id: lensTypeId,
          quantity: 1,
          properties: {
            '_p_groupId': this.groupId,
            '_p_productType': 'addon',
            '_p_addonType': 'lensType',
            '_p_mainProductId': mainProductId,
            '_tipo': this.getLensTypeName(),
            '_para_producto': this.getMainProductTitle(),
            '_precio_adicional_cristales': String(this.configurator.lensPrice || 0)
          }
        });
          // Añadir magnificación al addon de lente si existe
          try {
            const cfg = this.configurator.configuration || {};
            if (cfg.magnification) {
              const raw = String(cfg.magnification).trim();
              const normalized = raw.startsWith('+') ? raw.slice(1) : raw;
              items[items.length - 1].properties['_magnification'] = String(cfg.magnification);
              items[items.length - 1].properties['Graduación'] = normalized;
            }
          } catch (e) {}
      }
    }
    
    // 3. Addon: Material
    if (this.configurator.configuration.material && 
        this.configurator.configuration.material !== 'standard') {
      const materialId = this.ADDON_PRODUCT_IDS.materials[this.configurator.configuration.material];
      if (materialId) {
        items.push({
          id: materialId,
          quantity: 1,
          properties: {
            '_p_groupId': this.groupId,
            '_p_productType': 'addon',
            '_p_addonType': 'material',
            '_p_mainProductId': mainProductId,
            '_material': this.getMaterialName(),
            '_para_producto': this.getMainProductTitle(),
            '_precio_adicional_cristales': String(this.configurator.lensPrice || 0)
          }
        });
      }
    }
    
    // 4. Addons: Tratamientos
    if (this.configurator.configuration.treatments && Array.isArray(this.configurator.configuration.treatments)) {
      this.configurator.configuration.treatments.forEach(treatment => {
        const treatmentId = this.ADDON_PRODUCT_IDS.treatments[treatment];
        if (treatmentId) {
          const addonProps = {
            '_p_groupId': this.groupId,
            '_p_productType': 'addon',
            '_p_addonType': 'treatment',
            '_p_mainProductId': mainProductId,
            '_para_producto': this.getMainProductTitle(),
            '_precio_adicional_cristales': String(this.configurator.lensPrice || 0)
          };

          // Si el tratamiento seleccionado es photocromatic y existe color, persistirlo en las properties
          try {
            const cfg = this.configurator.configuration || {};
            if (treatment === 'photocromatic' && cfg.photocromatic_color) {
              addonProps['_photocromatic_color'] = cfg.photocromatic_color;
              // También añadir representación legible para _tratamientos si es usado
              addonProps['_tratamientos'] = (addonProps['_tratamientos'] || '') + ` photocromatic:${cfg.photocromatic_color}`;
            }
          } catch (e) {}

          items.push({ id: treatmentId, quantity: 1, properties: addonProps });
        }
      });
    }
    
    // Debug: imprimir items si se activa el flag global
    try { if (typeof window !== 'undefined' && window.LENS_DEBUG) console.debug('[LENS DEBUG] LensCartMultiProduct.buildCartItems ->', items); } catch (e) {}
    return items;
  }

  /**
   * Construye properties de configuración para el producto principal
   */
  buildConfigurationProperties() {
    const config = this.configurator.configuration;
    const properties = {};
    
    // Información legible
    if (config.lensType) {
      properties['_tipo_de_cristal'] = this.getLensTypeName();
    }
    
    if (config.material) {
      properties['_material'] = this.getMaterialName();
    }
    
    if (config.treatments && config.treatments.length > 0) {
      properties['_tratamientos'] = config.treatments
        .map(t => this.getTreatmentName(t))
        .join(', ');
    }

    // Añadir color photocromatic a properties del producto principal si existe
    try {
      if (config.photocromatic_color) {
        properties['_photocromatic_color'] = config.photocromatic_color;
      }
    } catch (e) {}
    
    // Prescripción si existe
    if (Object.keys(config.prescription).length > 0) {
      // Marcar internamente que hay prescripción sin exponer etiqueta legible
      properties['_con_prescripcion'] = 'sí';
      // No incluir datos sensibles de prescripción en properties
    }
    
    // Precio total calculado (simplificado hasta implementar cálculo dinámico)
    const basePrice = this.configurator.basePrice || 0;
    const lensPrice = this.configurator.lensPrice || 0;
    const totalPrice = basePrice + lensPrice;
    
  properties['_precio_total_configuracion'] = this.configurator.formatPrice(totalPrice);
    
    return properties;
  }

  /**
   * Añade todos los items al carrito usando el endpoint /cart/add.js
   */
  async addToCart(mainProductId, mainProductQuantity = 1) {
    try {
      console.log('🛒 Iniciando multi-product cart add...');
      
      const items = this.buildCartItems(mainProductId, mainProductQuantity);
      console.log('📦 Items a añadir:', items);
      
      // Shopify acepta array de items en /cart/add.js
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ items: items })
      });
      
      if (response.ok) {
        const result = await response.json();
        console.log('✅ Multi-product añadido al carrito exitosamente:', result);
        
        // Disparar evento de éxito
        document.dispatchEvent(new CustomEvent('lens:cart:added', {
          detail: {
            items: items,
            groupId: this.groupId,
            result: result
          }
        }));
        
        return result;
      } else {
        const error = await response.json();
        console.error('❌ Error añadiendo multi-product al carrito:', error);
        throw error;
      }
      
    } catch (error) {
      console.error('💥 Error en multi-product cart add:', error);
      throw error;
    }
  }

  // Métodos helper para obtener nombres legibles
  getLensTypeName() {
    // Nota: Configuración dinámica - los nombres vienen de productos de Shopify
    // Por ahora devolver el valor raw hasta implementar búsqueda de productos
    return this.configurator.configuration.lensType || 'Desconocido';
  }

  getMaterialName() {
    // Nota: Configuración dinámica - los nombres vienen de productos de Shopify
    return this.configurator.configuration.material || 'Desconocido';
  }

  getTreatmentName(treatment) {
    // Nota: Configuración dinámica - los nombres vienen de productos de Shopify
    return treatment || 'Desconocido';
  }

  getMainProductTitle() {
    // Intentar obtener el título del producto desde el DOM
    const titleElement = document.querySelector('h1.product__title, .product-title, h1');
    return titleElement?.textContent?.trim() || 'Producto principal';
  }
}

// Integración con el configurador existente
if (typeof window !== 'undefined') {
  window.LensCartMultiProduct = LensCartMultiProduct;
}